











































































































import Vue from 'vue'
import moment from 'moment'
import { Table, TableColumn, Select, Option } from 'element-ui'
import { Team, FaceBookPage } from '@/types/teams'
import { EventDate } from '@/types/events'
import { DropdownOption } from '@/types/dropdownOption'
import { AbilitySubject, AbilityAction } from '@/abilitiesByRole'
import { Feature } from '@/featureFlags/featureFlags'
import { KeyDict } from '@/types'
import LeftSidebarLayout from '@/components/LeftSidebarLayout'
import TeamRoleList from '@/components/TeamRoleList'
import TeamGroupList from '@/components/TeamGroupList'
import TabDisplay from '@/components/TabDisplay'
import FtpSettings from '@/components/FtpSettings'
import StreamAuthSettings from '@/components/StreamAuthSettings'
import './TeamManagement.scss'
import { UserProfile } from '@/types/users'
import { Tab } from '@/types/tabs'

export default Vue.extend({
  name: 'TeamManagement',
  data: () => ({
    activeTab: 'general',
    createNewGroup: false,
    createNewRole: false
  }),
  computed: {
    canReadTeamSettings (): boolean {
      return this.$can(AbilityAction.Read, AbilitySubject.TeamSettings)
    },
    canCreateTeamSettings (): boolean {
      return this.$can(AbilityAction.Create, AbilitySubject.TeamSettings)
    },
    canEditTeamSettings (): boolean {
      return this.$can(AbilityAction.Edit, AbilitySubject.TeamSettings)
    },
    canSeeFtp (): boolean {
      //If self-serve active, only show ftp for superusers
      if (this.isSelfServe) return this.isSuperUser
      //Else show ftp to roles with access
      return this.$can(AbilityAction.Read, AbilitySubject.Ftp)
    },
    canSeeStreamAuth (): boolean {
      if (this.isSelfServe) return this.isSuperUser
      return this.$can(AbilityAction.Read, AbilitySubject.StreamAuth) && this.$hasFeature(Feature.STREAM_AUTHENTICATION)
    },
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE) ?? false
    },
    isSuperUser (): boolean {
      return this.userProfile?.role === 'superuser'
    },
    tabs (): Tab[] {
      return [
        { label: 'General', value: 'general', icon: '' },
         //Only offer Roles and Groups tabs if self-serve not active
        ...!this.isSelfServe ? [
          { label: 'Roles', value: 'roles', icon: '' },
          { label: 'Groups', value: 'groups', icon: '' }
        ] : []
      ]
    },
    userProfile (): UserProfile|null {
      return this.$store.direct.state.user.profile
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    removeTooltip (): string {
      const msg = '<p>Removing permissions here will stop us from collecting the comments.</p>' +
      '<p>To <i>really</i> retract the given permissions, you need to uninstall the KisweMobile facebook app.</p>'
      return msg
    },
    team (): Team {
      return this.$store.direct.state.team.team
    },
    facebookTable (): FaceBookPage[] {
      if (this.team.facebook) {
        return Object.values(this.team.facebook)
      }
      return []
    },
    haveFacebook (): boolean {
      return (this.team.facebook !== undefined)
    },
    defaultRegion: {
      get (): string {
        return this.currentRegion || 'us-east'
      },
      set (newRegion: string): void {
        this.updateDefaultRegion(newRegion)
      }
    },
    currentRegion (): string {
      return this.$store.direct.state.team.team.default_region ?? ''
    },
    regions (): DropdownOption[] {
      const castProps = this.$store.direct.state.team.castProperties
        //Copied from CreateEditCast component
      const r: KeyDict<string> = {}
      Object.keys(castProps).forEach(castPropertyId => {
        const castProperty = castProps[castPropertyId]
        if (castProperty?.type === 'region') {
          r[castProperty.name] = castPropertyId
        }
      })
      const sortedNames: string[] = Object.keys(r).sort()
      const regionlist: DropdownOption[] = []
      sortedNames.forEach((name: string) => {
        regionlist.push({ name: name, key: r[name] } as DropdownOption)
      })
      return regionlist
    },
    canEdit (): boolean {
      return this.$can('edit', 'TeamSettings')
    },
    disabledTooltip (): string {
      return this.canEdit ? '' : 'Admin privileges required to edit this setting.'
    }
  },
  methods: {
    accessUrl (): string {
      let url = 'https://www.facebook.com/v7.0/dialog/oauth?response_type=token&display=popup&client_id=252959139156040&redirect_uri='
      const redirect_uri: string = window.location.origin + '/addfacebook'
      const redirect_uri_enc: string = encodeURIComponent(redirect_uri)
      url += redirect_uri_enc
      url += '&scope=pages_show_list%2Cpages_read_engagement%2Cpages_read_user_content%2Cpublic_profile'
      return url
    },
    addFacebook (): void {
      const url: string = this.accessUrl()
      window.location.href = url
    },
    removeFacebook (): void {
      this.$store.direct.dispatch.team.removeFacebookPages()
    },
    renderExpiration (d: { expires_at?: EventDate}): string {
      const expires = d.expires_at
      if (expires === undefined) return '?'
      return moment(expires.seconds * 1000).format('YYYY/MM/DD hh:mm')
    },
    updateDefaultRegion (newRegion: string): void {
      this.$store.direct.dispatch.team.setDefaultRegion(newRegion)
    },
    tabChanged (tab: string): void {
      this.activeTab = tab
    },
    addNewRole (): void {
      // FIXME needs to be added
      /*
      const role: TeamRole = {
        name: 'test',
        team_id: this.activeTeam,
        abilities: {
          [AbilitySubject.Cast]: {
            actions: []
          }
        }
      }
      this.$store.direct.dispatch.abilities.addNewRole(role) */
    },
  },
  components: {
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-select': Select,
    'el-option': Option,
    LeftSidebarLayout,
    TeamRoleList,
    TeamGroupList,
    TabDisplay,
    FtpSettings,
    StreamAuthSettings
  }
})
